<template>
    <teleport to="body">
        <div v-if="visible" class="panel-settings-backdrop" :style="{zIndex: zBase + 9}" @click.stop="close" @touchend.stop.prevent="close" @contextmenu.stop.prevent="close"></div>
        <div v-if="visible" class="panel-settings-menu" :style="menuStyle" @click.stop @touchend.stop>
            <slot>
                <template v-for="(item, i) in items" :key="i">
                    <div v-if="item.type === 'divider'" class="panel-settings-divider"></div>
                    <div v-else class="panel-settings-item" @click="onItemClick(item)">
                        <span v-if="item.icon" class="panel-settings-icon" v-html="item.icon"></span>
                        <span>{{ item.label }}</span>
                        <span v-if="item.checked" class="panel-settings-check">
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                        </span>
                    </div>
                </template>
            </slot>
        </div>
    </teleport>
</template>

<script>
export default {
    name: 'PanelSettingsMenu',
    props: {
        items: { type: Array, default: () => [] },
        zBase: { type: Number, default: 100000 },
    },
    data() {
        return {
            visible: false,
            x: 0,
            y: 0,
        }
    },
    computed: {
        menuStyle() {
            return {
                position: 'fixed',
                left: this.x + 'px',
                top: this.y + 'px',
                zIndex: this.zBase + 10,
            }
        },
    },
    methods: {
        open(event) {
            const menuWidth = 220
            const menuHeight = 80
            let x = event.clientX
            let y = event.clientY
            if (x + menuWidth > window.innerWidth) x = window.innerWidth - menuWidth - 10
            if (y + menuHeight > window.innerHeight) y = window.innerHeight - menuHeight - 10
            this.x = x
            this.y = y
            this.visible = true
            setTimeout(() => {
                document.addEventListener('keydown', this.onEsc)
            }, 0)
        },
        close() {
            this.visible = false
            document.removeEventListener('keydown', this.onEsc)
        },
        onEsc(e) {
            if (e.key === 'Escape') this.close()
        },
        onItemClick(item) {
            if (item.action) item.action()
            this.close()
        },
    },
    beforeUnmount() {
        document.removeEventListener('keydown', this.onEsc)
    },
}
</script>

<style>
.panel-settings-backdrop {
    position: fixed;
    inset: 0;
    z-index: 100009;
}

.panel-settings-menu {
    background: #ffffff;
    border: 1px solid #e5e5ea;
    border-radius: 8px;
    padding: 4px 0;
    min-width: 200px;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12), 0 2px 8px rgba(0, 0, 0, 0.06);
    font-size: 13px;
    user-select: none;
}

.panel-settings-item {
    display: flex;
    align-items: center;
    padding: 6px 12px;
    cursor: pointer;
    color: #1c1c1e;
    gap: 8px;
    white-space: nowrap;
}

.panel-settings-item:hover {
    background: rgba(var(--panel-accent-rgb), 0.08);
}

.panel-settings-icon {
    width: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.panel-settings-check {
    margin-left: auto;
    color: var(--panel-accent-text);
    display: flex;
    align-items: center;
}

.panel-settings-divider {
    height: 1px;
    background: #e5e5ea;
    margin: 4px 0;
}

html.dark .panel-settings-menu {
    background: #1E2027;
    border-color: #26272F;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2);
}

html.dark .panel-settings-item {
    color: #F5F5F5;
}

html.dark .panel-settings-item:hover {
    background: rgba(var(--panel-accent-rgb), 0.12);
}

html.dark .panel-settings-divider {
    background: #26272F;
}

html.midnight .panel-settings-menu {
    background: #241F1B;
    border-color: #2C2823;
    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4), 0 2px 8px rgba(0, 0, 0, 0.2);
}

html.midnight .panel-settings-item {
    color: #EAE6E1;
}

html.midnight .panel-settings-item:hover {
    background: rgba(var(--panel-accent-rgb), 0.12);
}

html.midnight .panel-settings-divider {
    background: #2C2823;
}

html.cream .panel-settings-menu {
    background: #FEFCF8;
    border-color: #E8E3DA;
    box-shadow: 0 8px 30px rgba(76, 70, 60, 0.12), 0 2px 8px rgba(76, 70, 60, 0.06);
}

html.cream .panel-settings-item {
    color: #3D3832;
}

html.cream .panel-settings-item:hover {
    background: rgba(var(--panel-accent-rgb), 0.06);
}

html.cream .panel-settings-divider {
    background: #E8E3DA;
}

</style>
